import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InformacionSubidaScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';
import { PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { downloadFile } from '../../../../../../shared/utils/download';

export const InformacionSubidaContainer = () => {

	const api = new InformesDetalleAdapter();
	const apiPeriodos = new PeriodosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [año, setAño] = useState<any>(undefined);
	let [periodo, setPeriodo] = useState<any>(undefined);
	let [reunion, setReunion] = useState<any>(undefined);
	let [isLoading, setIsLoading] = useState<boolean>(false);

	let result: any;

	useEffect(()=>{
		getTiposContenido();
	  },[])
	
	const getTiposContenido = async () => {
		try {
			setIsLoading(true);
			result = await apiPeriodos.getTiposContenidoPeriodoAbierto();
			if(result.data && result.data!=="")
			{
				var data = ([ ...result.data ] || []);
				if(data.length > 0){						
					setAño(([ ...result.data ] || [])[0].año);
					setPeriodo(([ ...result.data ] || [])[0].periodo);
					setReunion(([ ...result.data ] || [])[0].reunion);
				}else{
					setAño(undefined);
					setPeriodo(undefined)
					setReunion(undefined);
				}
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
		setIsLoading(false);
	};

	const getDatosInforme = async (data: any) => {
		setIsLoading(true);
		setData([]);
		try {
			result = await api.ListarDatosSubidos(data);
			if(result.data && result.data!==""){
				setData([...result.data] || []);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};

	const onDataChange = async (filterData: any, data: any) => {
		setIsLoading(true);
		setData([]);
		try {
			result = await api.InformesDetalleUpdate(data);
			getDatosInforme(filterData);
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
			getDatosInforme(filterData);
		}
		setIsLoading(false);
	}

	const onDescargar =async (data: any) => {
		try {
			result = await api.DescargarDatosPeriodoAbierto(data);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data, 'DatosPeriodoAbierto_' + data.IdCentroDesde + '.xlsx');
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      		exceptionError(exception);
		}
	}
	

	return (
		<>
			<InformacionSubidaScreen data={data} onFilter={getDatosInforme} año={año} periodo={periodo} reunion={reunion} isLoading={isLoading} onDataChange={onDataChange} onDescargar={onDescargar} />
		</>
	);
};

export default InformacionSubidaContainer;

